import * as React from 'react';

import styles from './index.css';
import { MobileFullScreenGalleryContainer } from '../../../containers/MobileFullScreenGallery';
import { INeighbourhoodSchema } from '../../../types';
import { isArrayWithItems } from '../../../utils/helpers';
import { ThumbsGallery } from '../../common/thumbs_gallery';
import { Card } from '../card';
import { PopupMobile } from '../popup_mobile';

export interface INeighborhoodLayoutStateProps {
  neighbourhoodList: INeighbourhoodSchema[];
}

export type TNeighborhoodLayout = INeighborhoodLayoutStateProps;

interface INeighborhoodLayoutState {
  currentSlide: number;
}

export class NeighborhoodLayout extends React.Component<TNeighborhoodLayout, INeighborhoodLayoutState> {
  public state = {
    currentSlide: 0,
  };

  public render() {
    const { neighbourhoodList } = this.props;
    const { currentSlide } = this.state;

    if (!isArrayWithItems(neighbourhoodList)) {
      return null;
    }

    return (
      <Card>
        <h2 className={styles['title']}>Окрестности</h2>
        <PopupMobile
          animation="opacity"
          popupContent={({ onClose }) => (
            <MobileFullScreenGalleryContainer startWithSlide={currentSlide} onClose={onClose} startFromNeighbourhood />
          )}
        >
          <ThumbsGallery thumbs={neighbourhoodList} onSlideClick={this.openSlide} isMobileVersion />
        </PopupMobile>
      </Card>
    );
  }

  private openSlide = (index: number) => {
    this.setState({ currentSlide: index });
  };
}
